import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option:
      "a) Proporcionar a melhor experiência dos Stakeholders ao interagir com a Boehringer através da Força de Vendas.",
    correct: false,
  },
  {
    option:
      "b) Preparar o ambiente para lançamentos futuros e desenvolver Competências da Força de Vendas.",
    correct: false,
  },
  {
    option: "c) Fomentar o aprendizado contínuo e a inovação.",
    correct: false,
  },
  {
    option: "d) Todas as anteriores.",
    correct: true,
  },
];

export default function Question2(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question2: {
          title:
            "Quais são os impulsionadores da área de Treinamento e Desenvolvimento?",
          option: option.option,
          correct: option.correct,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        Quais são os impulsionadores da área de Treinamento e Desenvolvimento?
      </h5>

      <div className="div-options-question-boe">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-boe ${
              optionSelected === e.option && "selected-option-question-boe"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
